module.exports = __webpack_public_path__ + "static/media/point_0.a21553ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/point_0.png
// module id = 16
// module chunks = 0